"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var config_context_1 = require("./config-context");
function useConfig() {
    var context = react_1.useContext(config_context_1.ConfigContext) || {};
    return tslib_1.__assign({ classPrefix: config_context_1.DEFAULT_CLASS_PREFIX, locale: config_context_1.DEFAULT_LOCALE }, context);
}
exports.useConfig = useConfig;
//# sourceMappingURL=use-config.js.map